import { StepLayout } from 'components/StepLayout/StepLayout';
import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { SelectProductsStepOptions } from './components/SelectProductsStepOptions';
import { BI_ACTION_NAME, BI_STEP_NAME } from 'config/bi';
import { biEvents } from 'api/bi-events';
import { StepId } from 'config/steps';
import { useAppStore } from 'stores/appStore';
import { Transition } from 'components/Transition/Transition';

export const SelectProductsStep: FC = () => {
  const { t } = useTranslation();
  const selectedProducts = useAppStore((state) => state.selectedProducts);

  return (
    <StepLayout
      title={t('select-products-step.title')}
      description={t('select-products-step.description')}
      nextButtonProps={{
        label: t('select-products-step.actions.primary-button'),
        disabled: !selectedProducts.length,
      }}
      onBack={() => {
        biEvents.actionClicked({
          screenName: BI_STEP_NAME[StepId.SelectProducts],
          action: BI_ACTION_NAME.BACK,
        });
      }}
      onNext={() => {
        biEvents.actionClicked({
          screenName: BI_STEP_NAME[StepId.SelectProducts],
          value: selectedProducts.join(','),
          action: BI_ACTION_NAME.CONTINUE,
        });
      }}
    >
      <SelectProductsStepOptions />
    </StepLayout>
  );
};
